







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ETirePosition, IEvaluatedVehicleSet } from '@/services/network-if';
import BasicTreadValue from '@/components/measview/basic-tread-value.vue';
import { ttmConfig } from '@/services/config';

@Component({
    components: { BasicTreadValue }
})

export default class BasicView extends Vue {
    @Prop() evalData!: IEvaluatedVehicleSet;
    ETirePosition = ETirePosition;
    liteSkin = true;

    mounted (): void {
        this.liteSkin = ttmConfig.liteSkin;
    }

    getTr(id: string): string {
        return this.$t(id) as string;
    }
}
